/**
 * 저작 job 폴링 — **서버 데이터 축**(TanStack Query). 실행 상태(Zustand)와 섞지 않는다.
 *
 * B 설계는 "폴링 우선, SSE 승격은 B-5" 다. 폴링 간격은 §9 지표(상태 변화 → 화면 반영 ≤ 5초)를
 * 만족해야 하므로 3초로 둔다 — 8~9분 런에서 3초 폴링은 180회 남짓이라 부담이 아니다.
 *
 * **끝나면 멈춘다**: 종결 상태에서 계속 폴링하면 사용자가 화면을 켜둔 하루 내내 빈 요청이 간다.
 */
import { useQuery } from '@tanstack/react-query'

import { UnauthorizedError } from '@/api/client'
import { fetchThreadJob } from './api'
import { isActive } from './types'
import type { ThreadJobResponse } from './types'

export const POLL_INTERVAL_MS = 3_000

export function threadJobKey(threadId: string | null): readonly unknown[] {
  return ['masterplan-job', threadId] as const
}

export function useThreadJob(threadId: string | null) {
  return useQuery<ThreadJobResponse>({
    queryKey: threadJobKey(threadId),
    queryFn: () => fetchThreadJob(threadId as string),
    enabled: Boolean(threadId),
    // 진행 중일 때만 다시 묻는다. 종결됐으면 값은 더 이상 바뀌지 않는다.
    refetchInterval: (query) =>
      isActive(query.state.data?.job) ? POLL_INTERVAL_MS : false,
    // 탭이 숨겨져 있어도 계속 본다 — 저작은 8~9분이고, 그 사이 사용자가 다른 탭을 보는 것이
    // 정상 사용이다(B 의 전제: 기다리지 않아도 된다). 돌아왔을 때 최신이어야 한다.
    refetchIntervalInBackground: true,
    retry: (count, error) => !(error instanceof UnauthorizedError) && count < 2,
    staleTime: 0,
  })
}
